import { Science } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import React from "react";

const CellPanelSelector: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);

  return (
    <Box>
      <Paper
        sx={{
          mb: 4,
          p: 4,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: -50,
            right: -50,
            opacity: 0.1,
          }}
        >
          <Science sx={{ fontSize: 200 }} />
        </Box>
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: 700,
              mb: 2,
              textShadow: "0 2px 4px rgba(0,0,0,0.1)",
              letterSpacing: "-0.5px",
            }}
          >
            Cell Panel Selector
          </Typography>
          <Typography
            variant="body1"
            color="rgba(255,255,255,0.9)"
            sx={{
              fontSize: "1.1rem",
              textShadow: "0 1px 2px rgba(0,0,0,0.1)",
              display: "inline",
            }}
          >
            Generate bespoke cell panels based on targets of interest.
          </Typography>
          <Button
            variant="outlined"
            size="small"
            sx={{
              ml: 2,
              color: "white",
              borderColor: "white",
              verticalAlign: "middle",
            }}
            onClick={() => setOpen(true)}
          >
            Learn More
          </Button>
          <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
            <DialogContent sx={{ position: "relative", p: 0 }}>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                  zIndex: 1,
                }}
              >
                <CloseIcon />
              </IconButton>
              <img
                src="/cell_panel_selector_info.png"
                alt="Cell Panel Selector Info"
                style={{ maxWidth: "100%", height: "auto", display: "block" }}
              />
            </DialogContent>
          </Dialog>
        </Box>
      </Paper>

      <Box sx={{ position: "relative", width: "100%", minHeight: "1200px" }}>
        {loading && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              p: 4,
              bgcolor: "white",
              borderRadius: 2,
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <CircularProgress size={48} />
            <Typography variant="body1" color="text.secondary">
              Loading Cell Panel Selector...
            </Typography>
          </Box>
        )}

        <iframe
          src="https://zaro-lab.shinyapps.io/Cell-Panel-Explorer-With-Cysteines/"
          style={{
            width: "100%",
            height: "1200px",
            border: "none",
            display: "block",
            opacity: loading ? 0.3 : 1,
            transition: "opacity 0.3s ease",
          }}
          title="Cell Panel Selector"
          onLoad={() => setLoading(false)}
        />
      </Box>
    </Box>
  );
};

export default CellPanelSelector;
